import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Table from 'views/agent/financial/comisiones/table.js'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the comisionesView.
 * @extends JetView
 */
export default class comisionesView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration

        const right = {
            type: 'wide',
            rows: [], // Placeholder for future rows
        };

        const toolbar = {
            view: 'toolbar', // Toolbar component
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5, // Horizontal padding
            paddingY: 5, // Vertical padding
            height: 40, // Height of the toolbar
            cols: [
                {
                    view: 'pager', // Pager component for pagination
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pagination template
                    autosize: false, // Disable autosizing
                    height: 35, // Height of the pager
                    size: devConfig.getDefaultDataFetch(), // Default size from configuration
                },
            ],
        };

        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme, // Apply current theme
                    elements: [
                        { view: 'label', label: _('Comisiones'), width: 150 }, // Label for the toolbar
                    ],
                },
                Table, // Table component for displaying data
                toolbar, // Include the previously defined toolbar
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        return {
            type: 'wide', // Layout type
            cols: [left], // Left column configuration
        };
    }
}

// FILE DOCUMENTED
